import { render, staticRenderFns } from "./homework-item.vue?vue&type=template&id=6f735920&scoped=true"
import script from "./homework-item.vue?vue&type=script&lang=js"
export * from "./homework-item.vue?vue&type=script&lang=js"
import style0 from "./homework-item.vue?vue&type=style&index=0&id=6f735920&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f735920",
  null
  
)

export default component.exports